import { useParams } from "react-router-dom";

import { usePayment } from "modules/transactions";

import type { ObjectWithId } from "utils/ObjectWithId";

export function useRuleScoreItem() {
  const { id } = useParams<ObjectWithId>();
  const { payment: data } = usePayment({ id });

  return { data };
}
